export const fetchSearchOptions = async (geoserverUrl, layerName) => {
    if (layerName !== '') {
        const url = `${geoserverUrl}?service=WFS&version=1.0.0&request=GetFeature&typeName=${layerName}&outputFormat=application/json&propertyName=dpa_descan`;
        const response = await fetch(url);
        const data = await response.json();
        const dpaList = data.features.map(feature => ({
            dpa_descan: feature.properties.dpa_descan,
            bbox: feature.bbox
        }));
        return dpaList;
    } else {
        return '';
    }
};